import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import "./loader.css";

const Loader = () => {
  const showLoader = useSelector((state) => state.loader.showLoader);

  if (!showLoader) {
    return null;
  }

  return (
    <div className="app-loader-wrapper">
      <Spin
        indicator={
          <LoadingOutlined style={{ fontSize: 48, color: "#28398A" }} spin />
        }
      />
    </div>
  );
};

export default Loader;
